import { getSumOfSelectedConcepts } from '@/returns/helpers/helpers'
import useRefundMethodExtra from '@/returns/hooks/useRefundMethodExtra/useRefundMethodExtra'
import { shouldShowRefundMethodExtra } from '@/returns/pages/TransactionIssueRefundPage/helpers'
import useManualIssueRefund from '@/returns/pages/TransactionIssueRefundPage/hooks/useManualIssueRefund'

const useIssueRefundForm = ({ show, transaction, returnId, onClose, onIssued, onError }) => {
  const refundType = transaction?.refund_info?.available_refund_type
  const {
    refundMethod,
    setRefundMethod,
    note,
    setNote,
    availableRefundMethods,
    getSelectedConcepts,
    isFormValid,
    onIssueRefund,
    isIssueRefundLoading,
    revertChanges,
  } = useManualIssueRefund({
    refundType,
    adjustMentRefundMethods: transaction?.refund_info?.adjustment_refund_methods,
    adjustmentConcepts: transaction?.refund_info?.adjustment_concepts,
    refundMethods: transaction?.refund_info?.refund_methods,
    refundConcepts: transaction?.refund_info?.refund_concepts,
    returnId,
    initialSelectedConceptsValue: true,
    shippingSummaryAmount: transaction?.summary?.bonuses?.shipping_amount,
    lineItems: transaction?.line_items,
    lineItemGroups: transaction?.line_item_groups,
  })

  const { amount: refundMethodExtraAmount } = useRefundMethodExtra({
    returnId,
    amount: getSumOfSelectedConcepts(getSelectedConcepts()),
    refundMethod,
    skip: !show,
  })

  const onCancel = () => {
    revertChanges()
    onClose()
  }

  const onAccept = async () => {
    try {
      const response = await onIssueRefund()

      revertChanges()
      onIssued(response)
    } catch (error) {
      onError(error)
    }
  }

  return {
    refundMethod,
    setRefundMethod,
    note,
    setNote,
    availableRefundMethods,
    selectedConcepts: getSelectedConcepts(),
    refundMethodExtraAmount,
    showExtra: shouldShowRefundMethodExtra(refundType, refundMethod, refundMethodExtraAmount),
    isFormValid,
    isIssueRefundLoading,
    onCancel,
    onAccept,
  }
}

export default useIssueRefundForm
